import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import {get} from 'lodash';
import withPlayerManager, {PLAYER_WAS_STARTED} from "./withPlayerManager";
import {loadToGlobalPlayer} from "./PopOutPlayer";
import ScrollingInspector from "./ScrollingInspector";
import InteractivePlayerContainer from "./InteractivePlayerContainer";
import {PLAYBACK_READY, VIDEO_FINISHED} from "./PlayerEventNames";
import {isServer} from "../../../utils";
import withErrorBoundary from "../../Errors/components/withErrorBoundry";

require('./Ooyala.scss');

export class Ooyala extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playerPlaceholderId: undefined,
      player: { pause: () => {}, isPlaying: () => false, getTitle: () => "", getState: () => "" },
      imageUrl: undefined,
      dismissed: false,
      thumbnailsByWidth: {},
      articleUrl: isServer() ? "" : window.location.pathname
    }
  }

  componentDidMount() {
    if (isServer()) {
      return;
    }
    window.addEventListener(PLAYER_WAS_STARTED, this.hidePopOutIfAnotherStartsPlaying)
  }

  componentWillUnmount() {
    if (this.playerIsInitialised()) {
      const {removePlayer} = this.props;

      if (this.state.player.isPlaying()) {
        loadToGlobalPlayer(this.state.player, this.state.articleUrl)
      }

      window.removeEventListener(PLAYER_WAS_STARTED, this.hidePopOutIfAnotherStartsPlaying)
      removePlayer(this.state.playerPlaceholderId)
    }
  }

  hidePopOutIfAnotherStartsPlaying = (event) => {
    if (event.detail.containerId !== this.state.playerPlaceholderId) {
      this.interactivePlayer.setPopOutState(false);
    }
  }

  onPlayerVisibilityChange = (isPlayerInViewport) => {
    if (!this.playerIsInitialised()) {
      return;
    }

    if (!this.state.player.isPlaying()) {
      if (isPlayerInViewport) {
        this.interactivePlayer.setPopOutState(false);
      }
      return;
    }

    if (this.state.dismissed) {
      !isPlayerInViewport && this.state.player.pause();
      return
    }

    this.interactivePlayer.setPopOutState(!isPlayerInViewport);
  }

  whenVideoIsFinished = () => {
    this.interactivePlayer.setPopOutState(false);
  };

  initialisePlayer = () => {
    const {contentId, createPlayer} = this.props;
    createPlayer(this.state.playerPlaceholderId, contentId, window.OO).then((playerData) => {
      playerData.player.mb.subscribe(VIDEO_FINISHED, '', this.whenVideoIsFinished);
      playerData.player.mb.subscribe(PLAYBACK_READY , '', () => {
        this.interactivePlayer.onPlayerReady();
      });

      const thumbnailsByWidth =
        get(playerData, 'metadata.primary_preview_image.sizes', [])
          .reduce((aggregator, val) => {
            return {...aggregator, [val.width]: val.url_ssl}
          }, {})

      this.setState({player: playerData.player, thumbnailsByWidth})
    });
  }

  playerIsInitialised = () => !!this.state.playerPlaceholderId;

  dismissPlayer = () => {
    if (!this.playerIsInitialised()) {
      return;
    }

    this.state.player.pause();
    this.interactivePlayer.setPopOutState(false)
    this.setState({
      dismissed: true
    });
  }

  setInteractivePlayer = ref => { this.interactivePlayer = ref }

  updatePlaceholder = (showPlaceholder) => {
    this.setState({
      showPlaceholder
    })
  }

  scrollPlaceholderIntoView = () => {
    const {playerPlaceholderId} = this.state;

    if (!playerPlaceholderId) {
      return;
    }

    const placeholderElement = document.getElementById('placeholder-' + playerPlaceholderId);
    if (!placeholderElement) {
      return;
    }

    const headerOffset = 250;

    const rect = placeholderElement.getClientRects()[0];
    window.scrollTo({
      top: (window.scrollY + rect.y) - headerOffset,
      behavior: 'smooth'
    });
  }

  render() {
    if (!this.playerIsInitialised()) {
      const playerPlaceholderId = `container_${uuid.v4()}`;
      this.setState({
        playerPlaceholderId
      }, this.initialisePlayer)
    }

    return (
      <ScrollingInspector
        playerPlaceholderId={this.state.playerPlaceholderId}
        thumbnails={this.state.thumbnailsByWidth}
        showPlaceholder={this.state.showPlaceholder}
        onVisibilityChange={this.onPlayerVisibilityChange}
      >
        <InteractivePlayerContainer
          ref={this.setInteractivePlayer}
          dismissPlayer={this.dismissPlayer}
          updatePlaceholder={this.updatePlaceholder}
          player={this.state.player}
          onMobilePopOutPress={this.scrollPlaceholderIntoView}
        >
          <div style={{minWidth: 'unset'}} id={this.state.playerPlaceholderId}/>
        </InteractivePlayerContainer>
      </ScrollingInspector>
    )
  }
}

Ooyala.propTypes = {
  contentId: PropTypes.string.isRequired,
  createPlayer: PropTypes.func,
  removePlayer: PropTypes.func
};

export default withErrorBoundary(withPlayerManager(Ooyala));



// WEBPACK FOOTER //
// ./modules/Ooyala/component/Ooyala.js